import React from 'react';

const AnaliseDefeitosBlock = ({
  styles,
  openAnaliseAccordion,
  analisesPeca,
  setAnalisesPeca,
  setPecasAnalisadas,
  setMainLancamentoRowData,
  setDefeitosGrid,
  deletarAnalisePecaDefeito,
  carregarStatus,
  openDefeitosAccordion,
  setOpenDefeitosAccordion,
  defeitosGrid,
  deletarDefeitoAnalisePeca
}) => {
  return (
    <>
      {openAnaliseAccordion && (
        <div className={styles.modalLancamentoGrid}
          style={{
            overflowX: analisesPeca.length > 1 ? 'auto' : 'hidden',
            whiteSpace: analisesPeca.length > 1 ? 'nowrap' : 'normal'
          }}
        >
          <table className={styles.analiseTable}>
            <colgroup>
              <col style={{ width: '7%' }} />
              <col style={{ width: '7%' }} />
              <col style={{ width: '7%' }} />
              <col style={{ width: '7%' }} />
              <col style={{ width: '11%' }} />
              <col style={{ width: '10%' }} />
              <col style={{ width: '8%' }} />
              <col style={{ width: '10%' }} />
              <col style={{ width: '9%' }} />
              <col style={{ width: '9%' }} />
              <col style={{ width: '8%' }} />
              <col style={{ width: '5%' }} />
            </colgroup>
            <thead>
              <tr className={styles.analiseTableHeader}>
                <th className={styles.analiseTh + ' ' + styles.analiseThFirst}>PEÇA</th>
                <th className={styles.analiseTh}>PEÇA CUSTOMIZADA</th>
                <th className={styles.analiseTh}>LOTE</th>
                <th className={styles.analiseTh}>LARGURA FORNECEDOR</th>
                <th className={styles.analiseTh}>LARGURA ENCONTRADA</th>
                <th className={styles.analiseTh}>% DIF.LARGURA</th>
                <th className={styles.analiseTh}>OURELA</th>
                <th className={styles.analiseTh}>LARGURA ÚTIL</th>
                <th className={styles.analiseTh}>METRAGEM FORNECEDOR</th>
                <th className={styles.analiseTh}>RELÓGIO</th>
                <th className={styles.analiseTh}>PONTUAÇÃO</th>
                <th className={styles.analiseTh}>STATUS</th>
                <th className={styles.analiseTh + ' ' + styles.analiseThLast}></th>
              </tr>
            </thead>
            <tbody>
              {analisesPeca.map((analise, idx) => (
                <React.Fragment key={idx}>
                  <tr>
                    <td className={styles.analiseTd + ' ' + styles.analiseTdBorder}>{analise.peca}</td>
                    <td className={styles.analiseTd + ' ' + styles.analiseTdBorder}>{analise.pecaCustomizada}</td>
                    <td className={styles.analiseTd + ' ' + styles.analiseTdBorder}>{analise.loteCustomizado === '' ? analise.lote : analise.loteCustomizado}</td>
                    <td className={styles.analiseTd + ' ' + styles.analiseTdBorder}>{analise.larguraFornecedor}</td>
                    <td className={styles.analiseTd + ' ' + styles.analiseTdBorder}>{analise.larguraEncontrada}</td>
                    <td className={styles.analiseTd + ' ' + styles.analiseTdBorder}>{analise.porcentagemDiferencaLargura}</td>
                    <td className={styles.analiseTd + ' ' + styles.analiseTdBorder}>{analise.ourela}</td>
                    <td className={styles.analiseTd + ' ' + styles.analiseTdBorder}>{analise.larguraUtil}</td>
                    <td className={styles.analiseTd + ' ' + styles.analiseTdBorder}>{analise.metragemFornecedor}</td>
                    <td className={styles.analiseTd + ' ' + styles.analiseTdBorder}>{analise.relogio}</td>
                    <td className={styles.analiseTd + ' ' + styles.analiseTdBorder}>{analise.pontuacao}</td>
                    <td className={styles.analiseTd + ' ' + styles.analiseTdBorder}>{analise.statusRevisao}</td>
                    <td className={styles.analiseTd}>
                      <button
                        type="button"
                        aria-label="Remover análise"
                        className={styles.analiseRemoveBtn}
                        onClick={async () => {
                          const id = analise.idMpTriangulacaoRevAnalisePeca;
                          if (!id || typeof deletarAnalisePecaDefeito !== 'function') return;
                          try {
                            const sucesso = await deletarAnalisePecaDefeito(id);
                            if (sucesso) {
                              setAnalisesPeca(prev => {
                                const removida = prev[idx];
                                const novaLista = prev.filter((_, i) => i !== idx);
                                setPecasAnalisadas(anterior => anterior.filter(p => p !== String(removida.peca)));
                                setMainLancamentoRowData(prevData => {
                                  if (!prevData) return prevData;
                                  if (String(prevData.peca) === String(removida.peca)) {
                                    return {
                                      ...prevData,
                                      peca: '',
                                      larguraFornecedor: '',
                                      larguraInicio: '',
                                      larguraMeio: '',
                                      larguraFim: '',
                                      ourela: '',
                                      metragemFornecedor: '',
                                      relogio: '',
                                      pontuacao: '',
                                    };
                                  }
                                  return prevData;
                                });
                                setDefeitosGrid(defeitos => defeitos.filter(d => d.peca !== removida.peca));
                                return novaLista;
                              });
                            } else {
                              alert('Erro ao remover análise no backend.');
                            }
                          } catch (e) {
                            alert('Erro ao remover análise no backend.');
                          }
                          await carregarStatus();
                        }}
                      >×</button>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={12} className={styles.analiseDivider}></td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* BLOCO 5: Accordion de Defeitos */}
      <div>
        <div
          style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '32px', marginBottom: '0', cursor: 'pointer' }}
          onClick={() => setOpenDefeitosAccordion(v => !v)}
          aria-expanded={openDefeitosAccordion}
          tabIndex={0}
          role="button"
        >
          <div className={styles.analiseSetaGrid}>
            <svg width="16" height="16" viewBox="0 0 16 16">
              {!openDefeitosAccordion ? (
                <path d="M4 7l4 4 4-4" stroke="#111" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
              ) : (
                <path d="M11 4l-4 4 4 4" stroke="#111" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
              )}
            </svg>
          </div>
          <div style={{ background: '#fff', minWidth: '100%', borderRadius: '4px', boxShadow: '0 2px 8px rgba(0,0,0,0.04)', display: 'flex', alignItems: 'center', zIndex: 1, marginLeft: '20px', padding: '5px 3px', marginBottom: '-30px' }}>
            <span style={{ fontWeight: 700, fontSize: '1rem', color: '#111' }}>Defeitos:</span>
          </div>
        </div>
        {openDefeitosAccordion && (
          <div
            className={styles.modalLancamentoGrid}
            style={{
              overflowX: defeitosGrid && defeitosGrid.length > 1 ? 'auto' : 'hidden',
              whiteSpace: defeitosGrid && defeitosGrid.length > 1 ? 'nowrap' : 'normal'
            }}
          >
            <table className={`${styles.analiseTable} ${styles.defeitosTable}`}>
              <colgroup>
                <col style={{ width: '7%' }} />
                <col style={{ width: '7%' }} />
                <col style={{ width: '7%' }} />
                <col style={{ width: '18%' }} />
                <col style={{ width: '18%' }} />
                <col style={{ width: '12%' }} />
                <col style={{ width: '24%' }} />
                <col style={{ width: '5%' }} />
                <col style={{ width: '2%' }} />
              </colgroup>
              <thead>
                <tr className={styles.analiseTableHeader}>
                  <th className={styles.analiseTh + ' ' + styles.analiseThFirst}>PEÇA</th>
                  <th className={styles.analiseTh}>PEÇA CUSTOMIZADA</th>
                  <th className={styles.analiseTh}>LOTE</th>
                  <th className={styles.analiseTh}>DEFEITO</th>
                  <th className={styles.analiseTh}>LOCALIZAÇÃO</th>
                  <th className={styles.analiseTh}>TAMANHO</th>
                  <th className={styles.analiseTh}>CONSIDERAÇÃO</th>
                  <th className={styles.analiseTh}>QTDE</th>
                  <th className={styles.analiseTh + ' ' + styles.analiseThLast}></th>
                </tr>
              </thead>
              <tbody>
                {defeitosGrid && defeitosGrid.length > 0 ? (
                  defeitosGrid.map((defeito, idx) => (
                    <React.Fragment key={defeito.idMpTriangulacaoRevDefeitosPeca || idx}>
                      <tr>
                        <td className={styles.analiseTd + ' ' + styles.analiseTdBorder}>{defeito.peca}</td>
                        <td className={styles.analiseTd + ' ' + styles.analiseTdBorder}>{defeito.pecaCustomizada}</td>
                        <td className={styles.analiseTd + ' ' + styles.analiseTdBorder}>{defeito.loteCustomizado === '' ? defeito.lote : defeito.loteCustomizado}</td>
                        <td className={styles.analiseTd + ' ' + styles.analiseTdBorder}>{defeito.nomeDefeito || defeito.idTipoDefeito}</td>
                        <td className={styles.analiseTd + ' ' + styles.analiseTdBorder}>{defeito.nomeLocDef || defeito.idLocalizacaoDefeito}</td>
                        <td className={styles.analiseTd + ' ' + styles.analiseTdBorder}>{defeito.tamanho || defeito.idTamanhoDefeito}</td>
                        <td className={styles.analiseTd + ' ' + styles.analiseTdBorder}>
                          <span style={{
                            background: '#f7f7f7',
                            borderRadius: 4,
                            padding: '2px 8px',
                            fontWeight: 500,
                            color: '#202D3B',
                            fontSize: '0.98rem',
                            maxWidth: 180,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            display: 'inline-block'
                          }}>{defeito.consideracaoDefeito}</span>
                        </td>
                        <td className={styles.analiseTd + ' ' + styles.analiseTdBorder}>{defeito.qtdeDefeitos}</td>
                        <td className={styles.analiseTd + ' ' + styles.analiseTdLast}>
                          <button
                            type="button"
                            aria-label="Remover defeito"
                            className={styles.analiseRemoveBtn}
                            onClick={async () => {
                              const idDefeito = defeito.idMpTriangulacaoRevDefeitosPeca;
                              const idAnalise = defeito.idMpTriangulacaoRevAnalisePeca;
                              if (!idDefeito || !idAnalise || typeof deletarDefeitoAnalisePeca !== 'function') return;
                              try {
                                const sucesso = await deletarDefeitoAnalisePeca(idDefeito, idAnalise);
                                if (sucesso) {
                                  setDefeitosGrid(prev => prev.filter((_, i) => i !== idx));
                                } else {
                                  alert('Erro ao remover defeito no backend.');
                                }
                              } catch (e) {
                                alert('Erro ao remover defeito no backend.');
                              }
                              await carregarStatus();
                            }}
                          >×</button>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={8} className={styles.analiseDivider}></td>
                      </tr>
                    </React.Fragment>
                  ))
                ) : (
                  <tr>
                    <td className={styles.analiseTd + ' ' + styles.analiseTdBorder}></td>
                    <td className={styles.analiseTd + ' ' + styles.analiseTdBorder}></td>
                    <td className={styles.analiseTd + ' ' + styles.analiseTdBorder}></td>
                    <td className={styles.analiseTd + ' ' + styles.analiseTdBorder}></td>
                    <td className={styles.analiseTd + ' ' + styles.analiseTdBorder}></td>
                    <td className={styles.analiseTd + ' ' + styles.analiseTdBorder}></td>
                    <td className={styles.analiseTd + ' ' + styles.analiseTdBorder}></td>
                    <td className={styles.analiseTd}></td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
};

export default AnaliseDefeitosBlock;
